import React from 'react';
import { Check } from 'lucide-react';

interface ServiceBenefitsProps {
  benefits: string[];
}

const ServiceBenefits = ({ benefits }: ServiceBenefitsProps) => {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container mx-auto">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-8">Why Choose Our Professional Services?</h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start space-x-3 bg-white p-6 rounded-lg shadow-sm">
                <Check className="h-6 w-6 text-ventura-green flex-shrink-0 mt-1" />
                <span className="text-gray-700 font-medium">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceBenefits;